import * as firebase from "firebase/app";
import "firebase/messaging";

  var firebaseConfig = {
        apiKey: "AIzaSyDU3q0vDYLwL1_eb7tMzcLcgJWU5qs3WrU",
        authDomain: "in-formed.firebaseapp.com",
        databaseURL: "https://in-formed.firebaseio.com",
        projectId: "in-formed",
        storageBucket: "in-formed.appspot.com",
        messagingSenderId: "583271795696",
        appId: "1:583271795696:web:d5e5105633166c24"
      };

const initializedFirebaseApp = firebase.initializeApp(firebaseConfig);


      // Initialize Firebase
      //firebase.initializeApp(firebaseConfig);
    let messaging = null;
try{


 messaging = initializedFirebaseApp.messaging();
messaging.usePublicVapidKey(
// Project Settings => Cloud Messaging => Web Push certificates
  "BKjid6UfUXPA9FnEPGz86MZtp8jG_PWexxclAfNRYNHr26uqkj_IVZSiSnSAq8yVXQEF5oc7FPWpL_q3i7DbDQU"
);
}
catch(e)
{
  
}
// messaging.onMessage((payload) => {
//   console.log('Message received. ', payload);
//   // ...
// });

export { messaging };


// WEBPACK FOOTER //
// ./src/init-fcm.js